import DollarTagIcon from '../../../../../icons/dollar-tag.svg';
import OptionsTailoredIcon from '../../../../../icons/optionsTailored.svg'
import LoanMatchProtectorIcon from '../../../../../icons/loanMatchProtector.svg';
import AcceptingPolicyIcon from '../../../../../icons/acceptingPolicy.svg';
import UnderwritingDecisionIcon from '../../../../../icons/underwritingDecision.svg';
import ApplicationProcessIcon from '../../../../../icons/applicationProcess.svg';
import BestPriceIcon from '../../../../../icons/bestPrice.svg';

export default function PurchasingProcessData() {
    return {
        title: "Our Purchasing Process",
        subtitle: "Streamline your experience with Covr's Loan Protection Life Insurance Quoter for personalized coverage that mirrors your loan repayment.",
        steps: [
            {
                title: "Get a Quote",
                icon: DollarTagIcon,
                paragraphs: [
                    "Covr makes it easy! Enter some basic information and use the online quoter to see an instant quote from the life insurance company.",
                ]
            },
            {
                title: "The Application Process",
                icon: ApplicationProcessIcon,
                paragraphs: [
                    "Select the coverage that fits your needs and start the application process. Enter your personal information, beneficiary information, and medical history all online and hassle free. Sign digitally using DocuSign and your application is ready for underwriting.",
                ]
            },
            {
                title: "Underwriting and decision",
                icon: UnderwritingDecisionIcon,
                paragraphs: [
                    "Once you sign the application, the life insurance company will make a decision based on the information provided in your application - no medical exam will  be required.",
                ]
            },
            ,
            {
                title: "Accepting your policy",
                icon: AcceptingPolicyIcon,
                paragraphs: [
                    "Assuming you accept the offer, your life insurance policy documents will be physically mailed from the life insurance company. If your application is not approved, don't worry - one of our licensed insurance experts will reach out to discuss other carrier and product options to help you obtain the coverage you need.",
                ]
            },
        ],
        stepsfooter:[
            {
                title: "What is LoanMatch <br/> Protector",
                icon: LoanMatchProtectorIcon,
                paragraphs: [
                    "With LoanMatch Protector, you can get the customized coverage you need at affordable prices. Because of the digital process, simplified application, and the decreasing coverage feature, this product is up to 30% more affordable when compared to other life insurance products.",
                ]
            },
            {
                title: "Get approved <br/> instantly",
                icon: OptionsTailoredIcon,
                paragraphs: [
                    "With LoanMatch Protector, you will get an instant decision online right from your phone, tablet, or computer. This is the most efficient way to purchase life insurance when compared to other options that can take weeks or months.",
                ]
            },
            {
                title: "Customized coverage at the <br/> best price",
                icon: BestPriceIcon,
                paragraphs: [
                    "With instant loan protection life insurance, you can get the customized coverage you need with the affordability of fully underwritten insurance without having to complete a medical exam. You can start your application and be approved online in minutes rather than the traditional application process that can take weeks or months.",
                ]
            },
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/LoanProtection/PurchasingProcessData.js